import api from 'services/technical-visit/technical-visit'

export const handleSave = async (values: any) => {
  let res = await api.addPart(values)

  return res?.data?.success
}
